export default "__VITE_ASSET__C5bFMSR1__"